import http from 'hub-http/clients/apiClient';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-base';
const API_KNOWLEDGE_CATEGORIES = '/knowledge-content/v1/knowledge-homepage-categories/buffer';
export default class TemplateSettingsBufferApi {
  static update(knowledgeBaseId, knowledgeBase, themeSettings) {
    const themeSettingsValues = themeSettings ? {
      values: themeSettings
    } : undefined;
    return http.put(`${API_BASE}/${knowledgeBaseId}/buffer/template-settings`, {
      data: {
        knowledgeBase,
        themeSettingsValues
      }
    });
  }
  static publish(knowledgeBaseId) {
    return http.post(`${API_BASE}/${knowledgeBaseId}/buffer/template-settings/publish`);
  }
  static updateHomepageCategory(knowledgeBaseId, homepageCategory) {
    return http.put(`${API_BASE}/${knowledgeBaseId}/buffer/homepage-organization`, {
      data: homepageCategory
    });
  }
  static updateKnowledgeHomepageCategory(homepageCategory, knowledgeBaseId) {
    return http.put(API_KNOWLEDGE_CATEGORIES, {
      data: homepageCategory,
      query: {
        knowledgeBaseId
      }
    });
  }
}
TemplateSettingsBufferApi.get = makeSimpleQuickFetchWrapper('get-template-settings', knowledgeBaseId => http.get(`${API_BASE}/${knowledgeBaseId}/buffer/template-settings`));